import React from 'react';
import { PropInfo, CodeExample, TooltipProps } from '@cimpress/react-components';
import TooltipCode from '!raw-loader!./tooltip.jsx';
import TooltipDemo from './tooltip.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

export default function TooltipDocs() {
  const propInfos: PropInfo<TooltipProps>[] = [
    {
      name: 'className',
      type: 'string',
      default: '',
      description: 'Can be used to manipulate the class name of the tooltip',
    },
    {
      name: 'containerClassName',
      type: 'string',
      default: '',
      description: 'Can be used to add class names to the tooltip target container',
    },
    {
      name: 'children',
      type: 'node (required)',
      default: '',
      description: 'DOM node for the tooltip to appear anchored to',
    },
    {
      name: 'contents',
      type: 'node',
      default: '',
      description: 'Contents for the tooltip',
    },
    {
      name: 'variant',
      type: 'string',
      default: 'tooltip',
      description: (
        <span>
          Controls the appearance. One of <code>tooltip</code> or <code>popover</code>.
        </span>
      ),
    },
    {
      name: 'direction',
      type: 'string',
      default: 'top',
      description: (
        <span>
          One of <code>top</code>, <code>right</code>, <code>bottom</code>, or <code>left</code>, tells the tooltip
          which direction to default to.
        </span>
      ),
    },
    {
      name: 'delay',
      type: 'number',
      default: '0',
      description: 'Delay (in milliseconds) after which the tooltip will be shown.',
    },
    {
      name: 'show',
      type: 'boolean',
      default: '',
      description:
        'Can be used to customize when the tooltip displays.  If this prop is used, the default mouseover behavior will be disabled.',
    },
    {
      name: 'onClickOutside',
      type: 'function',
      default: '',
      description: 'If provided, a function to be called when a click occurs outside of this component',
    },
    {
      name: 'style',
      type: 'object',
      default: '',
      description: 'Can be used to add styles to the parent container',
    },
    {
      name: 'tooltipStyle',
      type: 'object',
      default: '',
      description: 'Can be used to add styles to the tooltip component',
    },
    {
      name: 'tooltipInnerStyle',
      type: 'object',
      default: '',
      description: 'Can be used to add styles to the tooltip component',
    },
    {
      name: 'constraints',
      type: 'array',
      default: `[{
          to: 'window',
          attachment: 'together',
          pin: ['left', 'right']
        }]`,
      description: (
        <span>
          Allows the user to completely override the Tether <code>constraints</code> array for uniquely positioned
          tooltips. See the Tether.io documenation{' '}
          <a href="http://tether.io/#constraints" rel="noopener noreferrer" target="_blank">
            here
          </a>
          .
        </span>
      ),
    },
  ];

  return (
    <ComponentDoc name="Tooltip" propInfos={propInfos}>
      <TooltipDemo />
      <CodeExample code={TooltipCode} />
    </ComponentDoc>
  );
}
